import React, { useState } from 'react';
import { Row, Col, FormGroup } from 'reactstrap';
import { InputCheckbox } from '../../views/DayOff/form/style';

const WeekdaySelector = ({ onChange }) => {
  const [days, setDays] = useState({
    sun: false,
    mon: false,
    tue: false,
    wed: false,
    thu: false,
    fri: false,
    sat: false
  });

  const handleCheckboxChange = (day) => {
    const newDays = { ...days, [day]: !days[day] };
    setDays(newDays);
    onChange(newDays);
  };

  return (
    <Row>
      <Col>
        <label className="form-control-label">Repetir:</label>
        <FormGroup style={{ marginLeft: '4rem', marginTop: '-2rem' }}>
          <InputCheckbox>
            <input
              type="checkbox"
              checked={days.sun}
              className="checkbox-round-sun"
              onChange={() => handleCheckboxChange('sun')}
            />
            <h5 id="input-sun">D</h5>
            <input
              type="checkbox"
              checked={days.mon}
              className="checkbox-round-mon"
              onChange={() => handleCheckboxChange('mon')}
            />
            <h5 id="input-mon">S</h5>
            <input
              type="checkbox"
              checked={days.tue}
              className="checkbox-round-tue"
              onChange={() => handleCheckboxChange('tue')}
            />
            <h5 id="input-tue">T</h5>
            <input
              type="checkbox"
              checked={days.wed}
              className="checkbox-round-wed"
              onChange={() => handleCheckboxChange('wed')}
            />
            <h5 id="input-wed">Q</h5>
            <input
              type="checkbox"
              checked={days.thu}
              className="checkbox-round-thu"
              onChange={() => handleCheckboxChange('thu')}
            />
            <h5 id="input-thu">Q</h5>
            <input
              type="checkbox"
              checked={days.fri}
              className="checkbox-round-fri"
              onChange={() => handleCheckboxChange('fri')}
            />
            <h5 id="input-fri">S</h5>
            <input
              type="checkbox"
              checked={days.sat}
              className="checkbox-round-sat"
              onChange={() => handleCheckboxChange('sat')}
            />
            <h5 id="input-sat">S</h5>
          </InputCheckbox>
        </FormGroup>
      </Col>
    </Row>
  );
};

export default WeekdaySelector;
